export enum QuestionDisplayType {
    Radio = 1,
    Star = 2,
}
